import Home from '../../views/pc/Home.vue'
import Login from '../../views/pc/Login.vue'
import Register from '../../views/pc/Register.vue'
import Book from '../../views/pc/Book.vue'
import Partner from '../../views/pc/partner/Index.vue'
import PartnerDetail from '../../views/pc/partner/Detail.vue'
import Honored from '../../views/pc/Honored.vue'
import Guest from '../../views/pc/Guest.vue'
import Video from '../../views/pc/Video.vue'
import Score from '../../views/pc/Score.vue'
import Plan from '../../views/pc/Plan.vue'
import Branch from "../../views/pc/Branch";
import ContactDell from '../../views/pc/contact/Dell.vue'
import ContactMedia from '../../views/pc/contact/Media.vue'
import ContactSponsor from '../../views/pc/contact/Sponsor.vue'
import SponsorDetail from '../../views/pc/sponsor/Detail.vue'
import Error from '../../views/pc/Error.vue'
import Auth from '../../views/pc/Auth.vue'
import Edm from '../../views/pc/Edm.vue'
import Invitation from '../../views/pc/Invitation.vue'
import Info from '../../views/pc/Info.vue'
import Social from "../../views/pc/Social";
import DownLoad from "../../views/pc/interact/Download";
import Brand from "../../views/pc/interact/Brand";
import Paper from "../../views/pc/interact/Paper";
import Offline from "../../views/pc/Offline";
import UcenterPlan from "../../views/pc/ucenter/Plan";
import Exit from "../../views/pc/Exit";
import Forum2025 from "../../views/pc/Forum2025";

import Util from "@/common/util";


export default [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta:{
            keep:false,
            login:false,
            category:"首页",
            title:"首页-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网"
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta:{
            keep:false,
            login:false,
            category:"登录",
            title:"登录-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            hide_sponsor:true
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta:{
            keep:false,
            login:false,
            category:"报名",
            is_out: false,
            title:"",
            hide_sponsor:true
        }
    },
    {
        path: '/registration',
        name: 'Registration',
        component: Register,
        meta:{
            keep:false,
            login:false,
            is_out: true,
            category:"false",
            title:"会议报名丨2026戴尔科技峰会-戴尔(Dell)企业采购网",
            hide_sponsor:true
        }
    },
    {
        path: '/invitation',
        name: 'Invitation',
        component: Invitation,
        meta:{
            keep:false,
            login:false,
            is_out:true,
            no_common:true,
            category:"邀约",
            title:"",
            hide_sponsor:true
        }
    },
    {
        path: '/info',
        name: 'Info',
        component: Info,
        meta:{
            keep:false,
            login:false,
            is_out:true,
            no_common:true,
            category:"入场须知",
            title:"入场须知-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            hide_sponsor:true
        }
    },
    {
        path: '/offline',
        name: 'Offline',
        component: Offline,
        meta:{
            keep:false,
            login:false,
            category:"线下活动",
            title:"线下活动-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#ffffff",
            hide_sponsor:true,
            is_out: false,
        }
    },
    {
        path: '/ucenter/plan',
        name: 'UcenterPlan',
        component: UcenterPlan,
        meta:{
            keep:false,
            login:true,
            category:"我的日程",
            title:"我的日程-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f2f2f2",
            hide_sponsor:true
        }
    },
    {
        path: '/book',
        name: 'Book',
        component: Book,
        meta:{
            keep:false,
            login:false,
            category:"报名",
            title:"报名-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            hide_sponsor:true
        }
    },

    {
        path: '/interact/download',
        name: 'DownLoad',
        component: DownLoad,
        meta:{
            keep:false,
            login:false,
            category:"资料下载",
            title:"资料下载-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/interact/paper',
        name: 'Paper',
        component: Paper,
        meta:{
            keep:false,
            login:false,
            category:"调查问卷",
            title:"调查问卷-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/interact/brand',
        name: 'Brand',
        component: Brand,
        meta:{
            keep:false,
            login:false,
            category:"外星人之旅",
            title:"外星人之旅",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/partner/index',
        name: 'Partner',
        component: Partner,
        meta:{
            keep:false,
            login:false,
            category:"了解更多",
            title:"相关IT信息",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/partner/detail',
        name: 'PartnerDetail',
        component: PartnerDetail,
        meta:{
            keep:false,
            login:false,
            category:"了解更多",
            title:"产品详情",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/honored',
        name: 'Honored',
        component: Honored,
        meta:{
            keep:false,
            login:false,
            category:"专家面对面",
            title:"专家面对面-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/guest',
        name: 'Guest',
        component: Guest,
        meta:{
            keep:false,
            login:false,
            category:"嘉宾介绍",
            title:"嘉宾介绍-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/video',
        name: 'Video',
        component:Video,
        meta:{
            keep:false,
            login:false,
            category:"视频精选",
            title:"视频精选-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/score',
        name: 'Score',
        component:Score,
        meta:{
            keep:false,
            login:false,
            category:"互动专区",
            title:"积分",
            hide_sponsor:true
        }
    },
    {
        path: '/plan',
        name: 'Plan',
        component: Plan,
        meta:{
            keep:false,
            login:false,
            category:"主会场",
            title:"主会场-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6"
        }
    },
    {
        path: '/branch',
        name: 'Branch',
        component: Branch,
        meta:{
            keep:false,
            login:false,
            category:"分论坛",
            title:"分论坛-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网"
        }
    },
    {
        path: '/contact/dell',
        name: 'Dell',
        component: ContactDell,
        meta:{
            keep:false,
            login:false,
            category:"联系戴尔",
            title:"联系戴尔-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/contact/media',
        name: 'Media',
        component:ContactMedia,
        meta:{
            keep:false,
            login:false,
            category:"社交媒体",
            title:"社交媒体-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor: true,
        }
    },
    {
        path: '/contact/sponsor',
        name: 'Sponsor',
        component: ContactSponsor,
        meta:{
            keep:false,
            login:false,
            category:"赞助商",
            title:"赞助商-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/sponsor/detail',
        name: 'Detail',
        component: SponsorDetail,
        meta:{
            keep:false,
            login:false,
            category:"赞助商详情",
            title:"赞助商详情-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/social',
        name: 'Social',
        component: Social,
        meta:{
            keep:false,
            login:false,
            category:"社会责任",
            title:"社会责任-2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f6f6f6",
            hide_sponsor:true
        }
    },
    {
        path: '/forum',
        name: 'Forum2025',
        component: Forum2025,
        meta:{
            keep:false,
            login:false,
            no_common:true,
            category:"2026戴尔科技峰会",
            title:"2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网",
            background:"#f5f5f5",
            hide_sponsor:true
        }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        meta:{
            keep:false,
            login:true,
            no_common:true,
            hide_sponsor:true,
            title:"戴尔科技峰会"
        }
    },
    {
        path: '/exit',
        name: 'Exit',
        component: Exit,
        meta:{
            keep:false,
            login:false,
            no_common:true,
            hide_sponsor:true
        }
    },
    {
        path: '*',
        name: 'Error',
        component: Error,
        meta:{
            keep:false,
            login:false,
            hide_sponsor:true
        }
    }
]
